import { Box, Stack } from '@mui/material';
import { ButtonUI, DialogUI } from '../Interface';
import { sxConfig } from './joker.style';
import JokerSelectListTable from './JokerSelectListTable';
import { useFormikContext } from 'formik';

const JokerSelectListDialog = ({ dialogData, handleClose, defaultField }) => {
  const { open, valueIndex, originalValues } = dialogData;
  const { setFieldValue, validateForm } = useFormikContext();

  const resetForm = () => {
    setFieldValue(`fields.${valueIndex}.jokerValues`, originalValues);
  };

  const handleCloseDialog = () => {
    resetForm();
    handleClose();
  };

  const handleSave = async () => {
    const errors = await validateForm();

    const hasErrors =
      errors?.fields?.[valueIndex]?.jokerValues && Object.keys(errors.fields[valueIndex].jokerValues).length > 0;

    if (hasErrors) return;

    handleClose();
  };

  return (
    <DialogUI
      open={open}
      headerContent="Választólista elemek"
      fullWidth={true}
      onClose={handleCloseDialog}
      closeBtn={true}
      maxWidth="sm"
    >
      <Box sx={sxConfig.dialogContainer}>
        <JokerSelectListTable defaultField={defaultField} valueIndex={valueIndex} />
        <Stack direction="row" spacing={2} justifyContent="center">
          <ButtonUI text="Mentés" className="bg-success" onClick={handleSave} />
          <ButtonUI text="Mégsem" className="bg-primary" onClick={resetForm} />
        </Stack>
      </Box>
    </DialogUI>
  );
};

export default JokerSelectListDialog;
